<template>
  <div style="margin-bottom: 10px">
    <template v-if="loading.BankConciliation">
      <div style="text-align: center; padding: 10px">
        <loader :small="true" :isLoading="loading.BankConciliation"/>
      </div>
    </template>
    <template v-else>
      <d-form-row style="margin-right: 0px; margin-left: 0px">
        <d-col :md="mdSizes.conciliated" style="padding: 4px">
          <BankConciliationItemCard :BankConciliationItem="bankConciliation.Conciliated" />
        </d-col>

        <d-col :md="mdSizes.x" :class="'align-vertical ' + (!isConciliated ? 'conciliation-mode' : '')"
          :style="'text-align:center;' + (isConciliated ? 'padding:4px' : '')">
          <div class="middle-connector">
            <i class="fas fa-exchange-alt middle-icon"></i>
            <b-button v-if="isConciliated" size="sm" variant="outline-danger" class="mt-2" @click="Unconciliate()">
              <i class="fas fa-unlink mr-1"></i> Desconciliar
            </b-button>
          </div>
        </d-col>

        <d-col :md="mdSizes.toConciliate" :class="!isConciliated ? 'conciliation-mode' : ''" style="padding: 4px">
          <template v-if="isConciliated">
            <BankConciliationItemCard :BankConciliationItem="bankConciliation.ToConciliate" />
          </template>
          <template v-else>
            <div class="list-group">
              <a v-if="bankConciliation.Conciliated.EntryType.Code == 'C'" class="list-group-item" style="cursor: pointer" 
                data-toggle="tab" v-on:click="ChangeSelectedType('AddC')" :class="selectedType == 'AddC' ? 'active' : ''">
                <i class="fa fa-plus mr-2" style="font-size: 15px;"></i>
                <span class="item-title">Outras Entradas</span>
              </a>
              <a v-if="bankConciliation.Conciliated.EntryType.Code == 'C'" class="list-group-item" style="cursor: pointer" 
                data-toggle="tab" v-on:click="ChangeSelectedType('C')" :class="selectedType == 'C' ? 'active' : ''">
                <i class="fas fa-search mr-2" style="font-size: 15px;"></i>
                <span class="item-title">Contas a Receber</span>
              </a>
              <a v-if="bankConciliation.Conciliated.EntryType.Code == 'D'" class="list-group-item" style="cursor: pointer"
                data-toggle="tab" v-on:click="ChangeSelectedType('AddD')" :class="selectedType == 'AddD' ? 'active' : ''">
                <i class="fa fa-plus mr-2" style="font-size: 15px;"></i>
                <span class="item-title">Outras Saídas</span>
              </a>
              <a v-if="bankConciliation.Conciliated.EntryType.Code == 'D'" class="list-group-item" style="cursor: pointer" 
                data-toggle="tab" v-on:click="ChangeSelectedType('D')" :class="selectedType == 'D' ? 'active' : ''">
                <i class="fas fa-search mr-2" style="font-size: 15px;"></i>
                <span class="item-title">Contas a Pagar</span>
              </a>
              <a class="list-group-item" style="cursor: pointer" data-toggle="tab" v-on:click="ChangeSelectedType('T')"
                :class="selectedType == 'T' ? 'active' : ''">
                <i class="fas fa-exchange-alt mr-2" style="font-size: 15px;"></i>
                <span class="item-title">Transferências</span>
              </a>
            </div>
            <div v-if="selectedType">
              <template v-if="loading.MakeConciliation">
                <div style="text-align: center; padding: 10px">
                  <loader :small="true" :isLoading="loading.MakeConciliation"/>
                </div>
              </template>
              <template v-else-if="showInfo">
                <BankConciliationReceivable v-if="selectedType == 'C'" :filterOptions="filterData.filterOptions" 
                :conciliated="bankConciliation.Conciliated" @MakeConciliation="Conciliate" />
                <BankConciliationReceivableAdd v-if="selectedType == 'AddC'" :fieldOptions="filterData.filterOptions" 
                :conciliated="bankConciliation.Conciliated" @MadeConciliation="MadeConciliation"/>
                
                <BankConciliationPayable v-if="selectedType == 'D'" :filterOptions="filterData.filterOptions" 
                :conciliated="bankConciliation.Conciliated" @MakeConciliation="Conciliate" />
                <BankConciliationPayableAdd v-if="selectedType == 'AddD'" :fieldOptions="filterData.filterOptions" 
                :conciliated="bankConciliation.Conciliated" @MadeConciliation="MadeConciliation"/>

                <BankConciliationTransfer v-if="selectedType == 'T'" :filterData="filterData"
                :conciliated="bankConciliation.Conciliated" @MakeConciliation="Conciliate" />
              </template>
              <template v-else>
                <span style="text-align: center">
                  Não foi possivel verificar a conciliação.
                </span>
              </template>
            </div>
          </template>
        </d-col>
      </d-form-row>
    </template>
  </div>
</template>

<script>
import DateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";
import BankConciliationItemCard from "./BankConciliationItemCard.vue";
import BankConciliationReceivable from "./BankConciliationReceivable.vue";
import BankConciliationReceivableAdd from "./BankConciliationReceivableAdd.vue";
import BankConciliationPayable from "./BankConciliationPayable.vue";
import BankConciliationPayableAdd from "./BankConciliationPayableAdd.vue";
import BankConciliationTransfer from "./BankConciliationTransfer.vue";

export default {
  name: "BankConciliationModal",
  components: {
    DateField,
    DecimalField,
    BankConciliationItemCard,
    BankConciliationReceivable,
    BankConciliationReceivableAdd,
    BankConciliationPayable,
    BankConciliationPayableAdd,
    BankConciliationTransfer
  },
  props: {
    selectedBankConciliation:{
      type: Object,
      required: true,
    },
    filterData:{
      type: Object,
    },
  },
  data() {
    return {
      pageName: 'Conciliação de Lançamento Bancário',
      permissionName: 'BankConciliation',

      selectedType: 'Add' + this.selectedBankConciliation.EntryType.Code,
      bankConciliation: { Conciliated: this.selectedBankConciliation },

      loading:{
        BankConciliation: false,
        MakeConciliation: false
      },

      hasMadeGet: false,
      getHasError: false
    };
  },

  mounted() {
    this.GetBankConciliation();
  },

  computed: {
    isConciliated(){
      return this.bankConciliation.ToConciliate && this.bankConciliation.ToConciliate.Id != 0;
    },

    showInfo(){
      return this.hasMadeGet && !this.getHasError;
    },

    mdSizes(){
      if(this.isConciliated){
        return { conciliated: 5, x: 2, toConciliate: 5 }
      }else{
        return { conciliated: 3, x: 1, toConciliate: 8 }
      }
    },
  },

  watch:{
    selectedType(newValue, oldValue){
      console.log('aaaaa',newValue,oldValue)
    }
  },

  methods: {
    ChangeSelectedType(newValue){
      this.selectedType = newValue;
    },

    GetBankConciliation(){
      this.loading.BankConciliation = true;
      this.$store.dispatch("GetBankConciliation", this.bankConciliation.Conciliated.Id)
        .then(response => {
          this.bankConciliation = response;
        })
        .catch(error => {
          this.getHasError = true;
          this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao pegar a conciliação.", error);
        })
        .finally(() => {
          this.loading.BankConciliation = false;
          this.hasMadeGet = true;
        });
    },

    MadeConciliation(message){
      this.$emit('onChange');
      this.GetBankConciliation();
      if(message != undefined){
        this.$makeToast(...message);
      }
    },

    Conciliate(toConciliate){
      if(this.bankConciliation.Conciliated.Amount == toConciliate.Amount){
        this.loading.MakeConciliation = true;
        const payload = {
          Conciliated: this.bankConciliation.Conciliated,
          ToConciliate: toConciliate
        }
        this.$store.dispatch("Conciliate", payload)
        .then(response => {
          if(response){
            this.$makeToast(`Conciliação feita com sucesso.`, "success", `Conciliação feita com sucesso.`);
            this.MadeConciliation();
          }else{
            this.$makeToast("Não foi possivel conciliar.", "danger", "Não foi possivel conciliar.");
          }
        })
        .catch(error => {
          this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao conciliar.", error);
        })
        .finally(() => (this.loading.MakeConciliation = false));
      }else{
        this.$makeToast("Não é possivel conciliar pois os valores são diferentes.", "danger","Não é possivel conciliar");
      }
    },

    Unconciliate(){
      this.loading.BankConciliation = true;
      this.$store.dispatch("Unconciliate", this.bankConciliation)
      .then(response => {
        if(response){
          this.$makeToast(`Desconciliação feita com sucesso.`, "success", `Desconciliação feita com sucesso.`);
          this.MadeConciliation();
        }else{
          this.$makeToast("Não foi possivel desconciliar.", "danger", "Não foi possivel desconciliar.");
          this.loading.BankConciliation = false;
        }
      })
      .catch(error => {
        this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao desconciliar.", error);
        this.loading.BankConciliation = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .list-group {
  flex-direction: row;
}
/deep/ .list-group-item, /deep/ .list-group-item:last-child {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom: 0px;
}
.align-vertical {
  display: flex;
  justify-content: center;
  align-items: center;
}

.middle-connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.middle-icon {
  font-size: 22px;
  color: #adb5bd;
}
.selected-type-content {
  // display: flex;
  // flex-direction: column;
  min-height: 100%;
  margin-top: 1px;
  background:#00304d;
  padding: 5px;
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
/deep/ .p-component, /deep/ .p-component * {
  -webkit-box-sizing: unset;
  box-sizing: unset;
}
/deep/ .p-accordion .p-accordion-header:not(.p-disabled) .p-accordion-header-link:focus{
  box-shadow: unset;
}
/deep/ .p-accordion .p-accordion-header .p-accordion-header-link{
  background: #f7f9fb;
}
/deep/ .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link{
  background: #00304d;
  color: #ffffff
}
/deep/ .p-accordion .p-accordion-tab:first-child .p-accordion-header .p-accordion-header-link{
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-left: 1px;
}
/deep/ .dropdown .btn.btn-outline-secondary{
  padding: 6px 10px;
}
/deep/ .row .col .card.card-small.mb-4 .table {
  thead th, td{
    padding: .55rem;
    font-size: 13px;
  }
  thead th:first-of-type,
  td:first-of-type{
    padding: .15rem;
  }
  thead th:last-of-type,
  td:last-of-type{
    padding-right: .35rem;
  }
}
.col-md-1.conciliation-mode{
  width: fit-content;
  max-width: fit-content;
  padding: 5px;
}
.col-md-8.conciliation-mode{
  flex: 0 0 71.4%;
  max-width: 71.4%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BankConciliation/BankConciliationModal.vue